import { useAppConfig } from "./useAppConfig";
import { useRegionConfig } from "../../modules/TenantConfig/hooks/useRegionConfig";

export const useTenantLocalizedNamings = (enable = false) => {
  const { tenantPreferredLanguages } = useAppConfig();
  const { state: regionState } = useRegionConfig({ isAllLanguagesOnly: true, isAllLanguagesOnlyEnable: enable });

  const localizedNamings = (localeName, alias = false, aliasKey = null) => {
    const localizedNamings = tenantPreferredLanguages?.map((lang) => {
      const obj = {
        code: lang.code,
        lang:
          regionState.languagesOptions.find((l) => l.code === lang.code)
            ?.name || "",
        locale_name: localeName ? localeName[lang.code] || "" : "",
        isDefault: lang.default,
      };
      if (alias) obj[aliasKey] = alias[lang.code] || "";

      return obj;
    });
    return localizedNamings;
  };

  return {
    localizedNamings,
    regionState,
    isReady:
      tenantPreferredLanguages?.length > 0 &&
      regionState.languagesOptions?.length > 0,
  };
};
